import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const SubscriptionReturn = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showManualButton, setShowManualButton] = useState(false);

  useEffect(() => {
    const orderId = searchParams.get('order_id');
    const sid = searchParams.get('sid');

    console.log('[SubscriptionReturn] Received params:', {
      order_id: orderId,
      sid: sid,
      all_params: Object.fromEntries(searchParams.entries())
    });

    const params = new URLSearchParams();
    if (orderId) params.set('order_id', orderId);
    if (sid) params.set('sid', sid);

    // Show manual button after 5 seconds if automatic redirect hasn't happened
    const timeoutId = setTimeout(() => {
      setShowManualButton(true);
    }, 5000);

    // Always forward to the success page (it will handle missing params)
    const redirectTimeout = setTimeout(() => {
      if (orderId || sid) {
        navigate(`/subscription/success?${params.toString()}`, { replace: true });
      } else {
        // Even without params, let success page handle it (will use latest pending subscription)
        navigate('/subscription/success', { replace: true });
      }
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(redirectTimeout);
    };
  }, [searchParams, navigate]);

  const handleManualContinue = () => {
    const orderId = searchParams.get('order_id');
    const sid = searchParams.get('sid');
    const params = new URLSearchParams();
    if (orderId) params.set('order_id', orderId);
    if (sid) params.set('sid', sid);
    
    if (orderId || sid) {
      navigate(`/subscription/success?${params.toString()}`, { replace: true });
    } else {
      navigate('/subscription/success', { replace: true });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground mb-2">Completing your payment...</p>
        <p className="text-sm text-muted-foreground">You should be redirected automatically.</p>
        {showManualButton && (
          <div className="mt-6">
            <p className="text-sm text-muted-foreground mb-3">
              Taking longer than expected?
            </p>
            <Button onClick={handleManualContinue} variant="outline">
              Continue Manually
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubscriptionReturn;
